import { Injectable } from '@angular/core';
import { PaymentIntent } from "@stripe/stripe-js";
import { Observable } from 'rxjs';
import { HttpBaseService } from "@gea-waldviertler-website/shop-lib";

@Injectable()
export class HttpStripeService extends HttpBaseService {

  createPaymentIntent(amount: number): Observable<PaymentIntent> {
    let body = new URLSearchParams()
    body.set('amount', this.getCents(amount) + '') // cents as string

    return this.http.post<PaymentIntent>(
      this.envService.config.apiURL + "/stripe/create-payment-intent",
      body,
      this.getFormUrlEncodedHeader()
    )
  }

  private getCents(number: number) {
    // Math.round(), because parseInt() does not round correctly
    return Math.round(number * 100)
  }
}
